"use client"

import { Dialog } from "@src/components/Dialog"
import InternalAddressView from "@src/components/InternalAddressView"
import {
  type ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react"

type AddressModalContextType = {
  openAddressModal: () => void
  closeAddressModal: () => void
}

const AddressModalContext = createContext<AddressModalContextType | undefined>(
  undefined
)

export function AddressModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openAddressModal = useCallback(() => setIsOpen(true), [])
  const closeAddressModal = useCallback(() => setIsOpen(false), [])

  const value = useMemo(
    () => ({ openAddressModal, closeAddressModal }),
    [openAddressModal, closeAddressModal]
  )

  return (
    <AddressModalContext.Provider value={value}>
      {children}

      <Dialog
        open={isOpen}
        onClose={closeAddressModal}
        title="My near.com account address"
      >
        <InternalAddressView />
      </Dialog>
    </AddressModalContext.Provider>
  )
}

export function useAddressModal() {
  const context = useContext(AddressModalContext)

  if (!context) {
    throw new Error(
      "useAddressModal must be used within an AddressModalProvider"
    )
  }

  return context
}
